import React from 'react';
import './index.scss';
import { Bubble } from 'tea-component';
import GameImage from '@/pages/home/components/GameImage';
import TextBubblesDbi from '@/pages/intelligence/components/TextBubblesDbi';
import { WeiXinGameRender } from '@intelligence/pages/TopCharts/_config/TableCloums/WeiXinGameRender';
// import TipOne from '@/pages/intelligence/assets/svg/tipicon/tip-one.svg';
// import TipTwo from '@/pages/intelligence/assets/svg/tipicon/tip-two.svg';
// import TipThree from '@/pages/intelligence/assets/svg/tipicon/tip-three.svg';


interface FirstRowProps {
  cvm: any;
  renderDom?: React.ReactNode;
  /** id显示 如排名 */
  id?: number | string;
  // 排名是否有徽章效果，详见genre profile - insights - Market CR10 By Revenue
  hasBadge?: boolean;
  // 是否需要展示图片。默认展示图片
  showImg?: boolean;
  /** 是否显示下拉，下拉显示的数据 */
  popupData?: any[];
  className?: string;
  imgType?: string;
  /** 右键游戏跳转新链接 */
  rihgtClickToJumpHref?: string;
  onClick?: (...args: any[]) => void;
  // 下拉点击回调
  onDropdown?: (...args: any[]) => void;
  // 是否展示用户头像
  showUserImg?: boolean;
  // 是否展示整体hover提示内容
  ifNeedFirstRowBubble?: boolean;
  firstRowBubbleContent?: string;
  hasReleaseTime?: boolean;
  // icon右侧的dom
  iconRightDom?: React.ReactElement | null;
}

// const RANK_ICONS = [TipOne, TipTwo, TipThree];

const FirstRowCustom = (props: FirstRowProps) => {
  const {
    showImg = true,
    cvm,
    className,
    ifNeedFirstRowBubble = false,
    firstRowBubbleContent = '',
    id,
    imgType = '', // 从组件传入类型 ,非游戏cvm传入
  } = props;

  // console.debug('FirstRowCoustom', props);
  return (
    <Bubble
      arrowPointAtCenter
      dark
      style={{ maxWidth: 346 }}
      content={ifNeedFirstRowBubble ? firstRowBubbleContent : ''}
    >
      <div className={`dbi-firstRow-flex dbi-firstRow-custom ${className ? className : ''}`}>
        <span className="dbi-text-id">{id}</span>
        {showImg && <GameImage src={cvm?.img || cvm?.cover} entityType={imgType} className={'dbi-firstRow-imgone'} />}
        <div className="dbi-firstRow-gametitle">
          {WeiXinGameRender(cvm)}
          <div className="dbi-firstRow-right dbi-firstRow-bottom-text">
            <TextBubblesDbi text={cvm?.desc || cvm?.publisher || '-'} rowNum={2} isSubText={true} />
          </div>
        </div>
      </div>
    </Bubble>
  );
};

export default FirstRowCustom;
